import { useState, useEffect, useContext, useRef } from 'react';

import { PracticeReseveContext } from '../../../PracticeReseveContext';
import PracticeReserveDatetimeModalDate from './date/PracticeReserveDatetimeModalDate';


function PracticeReserveDatetimeModal(props: any) {

  const {
    calendar, chkCal,
  } = useContext(PracticeReseveContext);

  // 時間一覧表示の日付(他は閉じる)
  const [openDateKey, setOpenDateKey] = useState<string>('');
  const dateRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // 開いている日付が変わったら一番上になるようスクロール
  useEffect(() => {
    const target = dateRefs.current[openDateKey];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [openDateKey]);


  return (
    <>
      {Object.entries(calendar).map(([dateKey, dateInfo]: [string, any]) =>
        chkCal[dateKey] && (
          <>
            {/* 日付一覧 */}
            <PracticeReserveDatetimeModalDate
              dateKey={dateKey}
              dateInfo={dateInfo}
              openDateKey={openDateKey}
              setOpenDateKey={setOpenDateKey}
              dateRef={(el: HTMLDivElement | null) => {
                dateRefs.current[dateKey] = el;
              }}
            />
          </>
        )
      )}
    </>
  );
}
  
export default PracticeReserveDatetimeModal;